module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Eraser-c496c46ff50f492774829ecfb6a38d8b.svg";